import { useMemo } from 'react'
import { connect } from 'react-redux'
import { BnblPackageImageAndName } from './BnblPackageImageAndName'
import BnblPackageRooms from './BnblPackageRooms'
import BnblCancellationOptionPolicy from './BnblCancellationOptionPolicy'

interface MappedProps {
  bnblModalPackages: Array<App.BnblModal>
}

interface Props {
  offer: App.Offer
}

function BnblMultipleRoomPackage({
  offer,
  bnblModalPackages,
}: Props & MappedProps) {
  const roomPackages = useMemo(() => (
    bnblModalPackages.map(roomPackage => {
      const {
        duration,
        name: packageName,
        roomType: { name: roomTypeName, images },
        uniqueKey,
        cancellationOptionPolicy,
      } = roomPackage.packageView.package

      return { duration, packageName, roomTypeName, image: images[0], uniqueKey, cancellationOptionPolicy }
    })
  ), [bnblModalPackages])

  return (
    <>
      {roomPackages.map(pkg => (
        <>
          <BnblPackageImageAndName
            image={pkg.image}
            packageName={pkg.packageName}
            roomTypeName={pkg.roomTypeName}
          />
          <BnblCancellationOptionPolicy cancellationOptionPolicy={pkg.cancellationOptionPolicy} />
          <BnblPackageRooms
            offer={offer}
            packageKey={pkg.uniqueKey}
          />
        </>
      ))}
    </>
  )
}

function mapStateToProps(state: App.State, ownProps: Props): MappedProps {
  return {
    bnblModalPackages: state.offer.bnblModal[ownProps.offer.id],
  }
}

export default connect(mapStateToProps)(BnblMultipleRoomPackage)
